import React, { useCallback } from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';

interface LoanAmountInputProps {
  value?: Record<string, any>;
  onChange?: (data: Record<string, any>) => void;
  disabled?: boolean;
}

const LoanAmountInput: React.FC<LoanAmountInputProps> = ({
  value = {},
  onChange,
  disabled = false,
}) => {
  const currentValue = value?.loan_amount ?? '';

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    onChange?.({ loan_amount: val === '' ? '' : Number(val) });
  }, [onChange]);

  return (
    <div className="space-y-1.5">
      <Label htmlFor="loan_amount" className="text-sm font-medium text-gray-700">
        Requested Loan Amount
      </Label>
      <Input
        id="loan_amount"
        type="number"
        value={currentValue}
        onChange={handleChange}
        disabled={disabled}
        placeholder="e.g. 50000"
        className="mt-1"
      />
    </div>
  );
};

export default LoanAmountInput;
